import { useState, useCallback } from 'react';

const useToast = () => {
  const [toast, setToast] = useState({
    show: false,
    type: 'success',
    title: '',
    message: '',
    duration: 4000
  });

  const showToast = useCallback((type, title, message, duration = 4000) => {
    setToast({
      show: true,
      type,
      title: title || '',
      message: message || '',
      duration
    });
  }, []);

  const showSuccess = useCallback((title, message, duration) => {
    showToast('success', title, message, duration);
  }, [showToast]);

  const showWarning = useCallback((title, message, duration) => {
    showToast('warning', title, message, duration);
  }, [showToast]);

  const showError = useCallback((title, message, duration) => {
    showToast('error', title, message, duration);
  }, [showToast]);

  const showInfo = useCallback((title, message, duration) => {
    showToast('info', title, message, duration);
  }, [showToast]);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, show: false }));
  }, []);

  return {
    toast,
    showToast,
    showSuccess,
    showWarning,
    showError,
    showInfo,
    hideToast
  };
};

export default useToast;


